import { http } from '../utils/http';
import Pagination from '../interfaces/common/pagination';
import Paging from '../interfaces/common/paging';
import SortFormatterUtils from '../utils/sortFormatterUtils';
import YesNo from '../interfaces/output/YesNo';

export default class YesNoApi {
    static fetchYesNoById = async(yesNoId: string): Promise<YesNo> => {
        const { data } = await http.get<YesNo>(`yesNo/${yesNoId}`);

        return data;
    };

    static fetchYesNo = async(paging: Paging): Promise<Pagination<YesNo>> => {
        const url = SortFormatterUtils.addSortingToUrl(paging, null, '/yesNo');

        const { data } = await http.get<Pagination<YesNo>>(url);

        return data;
    };
}
